import clsx from 'clsx';
import { type Control, Controller, type FieldErrors } from 'react-hook-form';
import { IMaskInput } from 'react-imask';

import type { AlterPasswordlessCodeFormData } from '@/models/login.model';

interface LoginEmailInputProps {
  control: Control<AlterPasswordlessCodeFormData>;
  errors: FieldErrors<AlterPasswordlessCodeFormData>;
}

export const LoginOtpInput = ({ control, errors }: LoginEmailInputProps) => (
  <>
    <Controller
      name="otp"
      control={control}
      rules={{
        required: 'One time code is required',
        pattern: {
          value: /^\d{6}$/,
          message: 'Invalid code (format: xxxxxx)',
        },
      }}
      render={({ field: { ref, ...field } }) => (
        <IMaskInput
          data-testid="otpInput"
          {...field}
          mask="000000"
          placeholder="One time password"
          // Styling taken from src/components/Input.tsx
          className={clsx(
            `text-left h-14 px-4 w-full text-base font-light bg-alter-black-4`,
            `border rounded-2xl border-solid focus:outline-none`,
            `placeholder-text-alter-black-60`
            // error ? 'border-alter-error' : 'border-alter-black-10',
          )}
          autoComplete="off"
          inputRef={ref}
        />
      )}
    />
    {errors?.otp && <div className="mt-1 text-sm text-alter-error">{errors.otp.message}</div>}

    {/* <Input
      {...register('phone', { required: true })}
      placeholder="Otp Number"
      inputStyle="rounded"
      data-testid="phoneInput"
      autoComplete="phone"
    /> */}

    {/* {errors.email && errors.email.type === 'required' && (
      <div className="error" role="alert">
        Email Address is required
      </div>
    )} */}
  </>
);
